import Extractor from './extractor.js';

class App extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    result['store'] = (data['mobileapplication']) ? "Android" : (data['softwareapplication']) ? "Apple" : '-';

    result['name'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'name'},        
        {instance: data, object:'softwareapplication', property: 'name'},
      ], null);

    result['description'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'description'},        
        {instance: data, object:'softwareapplication', property: 'description'},
      ], null);

    result['filesize'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'filesize'},     
      ], null);

    result['published'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'datepublished'},
        {instance: data, object:'softwareapplication', property: 'datepublished'},   
      ], null);

    result['downloads'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'numdownloads'},  
      ], null);

    result['version'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'softwareversion'},  
        {instance: data, object:'softwareapplication', property: 'softwareversion'},      
      ], null);

    result['os'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'operatingsystems'},        
        {instance: data, object:'softwareapplication', property: 'operatingsystem'},      
      ], null);

    result['rating'] = this.getData(
      [
        {instance: data, object:'mobileapplication', property: 'contentrating'},        
      ], null);

    result['category'] = this.getData(
      [
        {instance: data, object:'softwareapplication', property: 'applicationcategory'},        
      ], null);


    return result;
  }
}

export default (App);


// WEBPACK FOOTER //
// ./src/search/extractor/app.js